import { render } from "./BigPic.vue?vue&type=template&id=d0ddfc92"
import script from "./BigPic.vue?vue&type=script&lang=js"
export * from "./BigPic.vue?vue&type=script&lang=js"

import exportComponent from "/root/workspace/Collection_EVMd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__